import { render, staticRenderFns } from "./DialogContentWhatsIncludedRentProtection.vue?vue&type=template&id=47aeb449&scoped=true&"
import script from "./DialogContentWhatsIncludedRentProtection.vue?vue&type=script&lang=js&"
export * from "./DialogContentWhatsIncludedRentProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aeb449",
  null
  
)

export default component.exports